<template>
  <div class="asset_detail">
    <a-descriptions bordered>
      <a-descriptions-item label="购置价值">{{ basic.kansw }}</a-descriptions-item>
      <a-descriptions-item label="现值">{{ basic.qmjz }}</a-descriptions-item>
      <a-descriptions-item label="已折旧价值">{{ basic.anbtr }}</a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import { getAssetValueDetail } from '@/api/assetLedger'
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        if (model) this.initValueDetail()
      },
      immediate: true
    }
  },
  data () {
    return {
      basic: {
        anbtr: '0',
        qmjz: '0',
        kansw: 0
      }
    }
  },
  methods: {
    // 获取数据
    initValueDetail () {
      const { model } = this
      const params = {
        anln1: model.anln1,
        bukrs: model.bukrs,
        anln2: model.anln2
      }
      console.log('initValueDetail', params)
      getAssetValueDetail(params).then(res => {
        // console.log('数据', res.data);
        if (res.status === 0) {
          this.basic = res.data
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.asset_detail {
  /deep/.ant-descriptions {
    .ant-descriptions-title {
      margin-bottom: 0;
      line-height: 32px;
      font-size: 12px;
      color: #333333;
      font-weight: 500;
      padding: 0 12px;
      border-right: 1px solid #e8e8e8;
      border-left: 1px solid #e8e8e8;
      background: #f9f9f9;
    }
    .ant-descriptions-view {
      border-radius: 0;
      width: 100%;
      .ant-descriptions-row {
        border-bottom: none;
        .ant-descriptions-item-label,
        .ant-descriptions-item-content {
          padding: 8px 12px;
          height: 40px;
          border-bottom: 1px solid #e8e8e8;
        }
        .ant-descriptions-item-label {
          background: #E7F4FF;
          width: 120px;
        }
        .ant-descriptions-item-content[colspan='1'] {
          width: 230px;
        }
        .ant-descriptions-item-content[colspan='3'] {
          width: 580px;
        }
        .ant-descriptions-item-content[colspan='5'] {
          width: 930px;
        }
      }
      .ant-descriptions-row:last-child {
        .ant-descriptions-item-label,
        .ant-descriptions-item-content {
          border-bottom: none;
        }
      }
    }
  }
}
</style>